import React from 'react';
import styles from '../css/modules/ContentPage.module.css';
import SEO from '../components/SEO';
import JsonLd from './JsonLd';
import Breadcrumbs from './Breadcrumbs';
import { FIRMA } from '../data/firma';
import { serviceSchema, breadcrumbSchema } from '../data/schema';

/*
 * UWAGA - ta strona zostala przepisana.
 *
 * Wczesniej pod adresem /trening-umiejetnosci-spolecznych/ stal drugi,
 * niemal identyczny landing na fraze "diagnoza integracji sensorycznej
 * Olsztyn": ten sam H1 co strona diagnozy, fraza w kazdym naglowku i wlasny
 * wezel MedicalBusiness. Dokladnie przypadek opisany w spec sekcji 4.
 *
 * Unikalne fragmenty (sprzet w sali, grupy odbiorcow) przeniesiono na
 * /terapia-integracji-sensorycznej-olsztyn/, a ten adres opisuje wreszcie
 * usluge, ktora nazywa: Trening Umiejetnosci Spolecznych.
 */

const PATH = '/trening-umiejetnosci-spolecznych/';

const CRUMBS = [
  { name: 'Strona główna', path: '/' },
  { name: 'Trening Umiejętności Społecznych', path: PATH },
];

const TRUDNOSCI = [
  'trudno mu nawiązać i utrzymać kontakt z rówieśnikami,',
  'nie wie, jak dołączyć do zabawy albo poprosić o pomoc,',
  'gwałtownie reaguje na przegraną, odmowę lub zmianę planów,',
  'ma kłopot z rozpoznawaniem emocji - własnych i cudzych,',
  'wycofuje się w grupie, choć w domu rozmawia swobodnie,',
  'często wchodzi w konflikty, mimo że nie chce nikogo skrzywdzić.',
];

export default function TreningUS() {
  const jsonLd = serviceSchema({
    path: PATH,
    name: 'Trening Umiejętności Społecznych (TUS) dla dzieci',
    serviceType: 'Trening Umiejętności Społecznych',
  });

  return (
    <div className={styles.page}>
      <SEO
        title="Trening Umiejętności Społecznych (TUS) dla dzieci | Sensorini Olsztyn"
        description="Trening Umiejętności Społecznych dla dzieci w Olsztynie: relacje z rówieśnikami, rozpoznawanie emocji i radzenie sobie w trudnych sytuacjach."
        image="/image/trening-umiejetnosci-spolecznych-TUS.webp"
        pathname={PATH}
        type="article"
      />
      <JsonLd data={[jsonLd, breadcrumbSchema(CRUMBS)]} />

      <header className={styles.hero}>
        <span className={`${styles.blob} ${styles.blobA}`} aria-hidden="true" />
        <span className={`${styles.blob} ${styles.blobB}`} aria-hidden="true" />
        <div className={styles.heroInner}>
          <span className={styles.eyebrow}>TUS • Olsztyn</span>
          <h1 className={styles.h1}>Trening Umiejętności Społecznych dla dzieci</h1>
          <p className={styles.lead}>
            Zajęcia, na których dziecko ćwiczy to, czego nie da się nauczyć z rozmowy: jak wejść do
            grupy, jak powiedzieć „nie”, jak przegrać i nie zepsuć zabawy.
          </p>
        </div>
      </header>

      <Breadcrumbs items={CRUMBS} />

      <div className={styles.wrap}>
        <img
          className={styles.figure}
          src="/image/trening-umiejetnosci-spolecznych-TUS.webp"
          alt="Zajęcia Treningu Umiejętności Społecznych dla dzieci w Olsztynie"
          loading="lazy"
        />

        <section className={styles.section}>
          <h2>Czym jest TUS?</h2>
          <p>
            Trening Umiejętności Społecznych to ustrukturyzowane zajęcia, na których dzieci uczą się
            zachowań przydatnych w kontakcie z innymi. Nowa umiejętność jest najpierw nazywana i
            pokazywana, potem ćwiczona w bezpiecznej sytuacji - w scence, grze, zadaniu zespołowym -
            a na końcu omawiana. Dzięki temu dziecko nie tylko wie, jak należy się zachować, ale ma
            już za sobą doświadczenie, że mu się to udało.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Kiedy warto rozważyć takie zajęcia?</h2>
          <p>Zajęcia mogą pomóc, jeśli u dziecka widzisz, że:</p>
          <ul className={styles.list}>
            {TRUDNOSCI.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
          <p className={styles.callout}>
            Trudności w relacjach mogą mieć bardzo różne podłoże. Czasem wynikają z nieśmiałości albo
            z braku okazji do ćwiczenia, czasem z przeciążenia bodźcami - i wtedy warto zacząć od{' '}
            <a href="/diagnoza-sensoryczna-olsztyn/">diagnozy integracji sensorycznej</a>. Zawsze
            wymaga to indywidualnej oceny.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Czego ćwiczymy na zajęciach?</h2>
          <ul className={styles.chips}>
            <li>rozpoznawanie i nazywanie emocji</li>
            <li>nawiązywanie kontaktu i dołączanie do zabawy</li>
            <li>proszenie o pomoc i odmawianie</li>
            <li>współpraca i dzielenie się</li>
            <li>radzenie sobie z przegraną i złością</li>
            <li>rozwiązywanie konfliktów</li>
            <li>zasady rozmowy: słuchanie, czekanie na swoją kolej</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Jak się umówić?</h2>
          <p>
            Skład grupy, częstotliwość i terminy ustalam indywidualnie - zależą od wieku dzieci i ich
            potrzeb. Zadzwoń pod <a href={`tel:${FIRMA.telefonE164}`}>{FIRMA.telefon}</a> albo napisz
            na <a href={`mailto:${FIRMA.email}`}>{FIRMA.email}</a>, a opowiem, co aktualnie mogę
            zaproponować. Ceny zajęć znajdziesz w <a href="/cennik/">cenniku</a>.
          </p>
          <p className={styles.muted}>
            Treść ma charakter edukacyjny i nie zastępuje indywidualnej diagnozy specjalistycznej.
            Autorka: <a href="/o-mnie/">{FIRMA.osoba}</a>, {FIRMA.rola.toLowerCase()}.
          </p>
        </section>
      </div>

      <section className={styles.ctaBand}>
        <div className={styles.ctaInner}>
          <h2>Chcesz zapytać o TUS?</h2>
          <p>Zadzwoń albo napisz - powiem, czy zajęcia będą dobrym rozwiązaniem dla Twojego dziecka.</p>
          <div className={styles.ctaBtns}>
            <a href={`tel:${FIRMA.telefonE164}`} className={styles.btnPrimary}>
              Zadzwoń: {FIRMA.telefon}
            </a>
            <a href="/kontakt/" className={styles.btnGhost}>
              Napisz wiadomość
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
